<template>
    <div class="gif-generator-main-cont" >
        
        <div class="pageBtns">
            <button @click="createCanvasImagesFromDivs">Create Images from Divs</button>
            <button @click="createGif" >Create Gif</button>
            <button @click="createCanvasImagesThenGif" >Create Images then Gif</button>
        </div>
        <div class="gif-divs-canvas-cont">
            <div class="created-gif-cont" ref="gifCont"></div>
            <div class="gif-card-templates">
                <div class="gif-img-template" v-for="(answer, index) in gifLocalData.quizAnswers" :key="index">
                    <div
                        ref="answers"
                        class="gif-img-template-content"
                        :class="{'gif-img-template-light' : gifLocalData.lightCard}"
                        :style="{backgroundColor: gifLocalData.quizColor}"
                    >
                        <div class="gif-img-question">{{gifLocalData.quizQuestion}}</div>
                        <div class="gif-img-answers">{{answer}}</div>
                        <div class="gif-img-ref">
                            <div class="result_instructions">Take a screenshot to see result</div>
                            <div class="referral_desc">Create your own quiz on {{siteDomain}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="gif-card-canvas-images" ref="mainCont">
                <img v-for="(imageURL, index) in imageObjects" :key="index" ref="flatImages" :src="imageURL" alt="" >
            </div>
            
        </div>
    </div>
</template>

<script>
// import html2canvas from 'html2canvas';
import domtoimage from 'dom-to-image';
import GIF from 'gif.js';

export default {
    name: 'gifGenerator',
    props: {
        gifData: Object,
    },
    data() {
        return {
            siteDomain: 'gifbanana.com',
            imageObjects: [],
            imagesLoaded: [],
            gifImage: {
                blobURL: null,
                imageBlob: null,
                url: null,
            },
            lightCard: true,
        }
    },
    methods: {
        createCanvasImagesFromDivs() {
            return new Promise((resolve) => {
                let cardElements = this.$refs.answers;
                let imageObjects = this.imageObjects;
                let answers = this.gifLocalData.quizAnswers;
                
                // Gif size is set in CSS '.gif-img-template'
                let firstAnswerElement = this.$refs['answers'][0];
                let imageWidth = firstAnswerElement.offsetWidth;
                let imageHeight = firstAnswerElement.offsetHeight;
                let scale = 4;

                let exportSettings = {
                    // ==== Export settings for DOM TO IMAGE library
                    width: imageWidth * scale,
                    height: imageHeight * scale,
                    style: {
                        transform: `scale(${scale})`,
                        transformOrigin: "top center",
                    },
                }
                let totalConvertedImages = 0;
                answers.forEach((answer , i) => {
                    domtoimage.toPng(cardElements[i], exportSettings)
                        .then(function(imageDataURL){
                            // image base64 data url
                            imageObjects.push(imageDataURL);
                            totalConvertedImages +=1;
                        })
                        .then(function(){
                            if (totalConvertedImages === answers.length) {
                                resolve('All divs converted to Canvas');
                            }
                        })
                        .catch(function (error) {
                            console.error('oops, something went wrong!', error);
                        });
                });
            });
        },
        async createCanvasImagesThenGif() {
            await this.createCanvasImagesFromDivs();            
            this.createGif();
        },
        createGif() {
            let gifElm = new GIF({
                workers: 4,
                quality: 10,
                workerScript: "/gif.worker.js",
                // debug: true,
            });
            let frameDelay = 100; // Gif animation speed in Ms
            let flatImages = this.$refs.flatImages;
            let loadedFramesCount = 0;
            
            // Add image from DOM as a frame to render a gif
            flatImages.forEach((imageELement) => {
                
                if (imageELement.complete) { //if the image is already loaded
                    loadedFramesCount += 1;
                    gifElm.addFrame(imageELement, {delay: frameDelay});
                    if(loadedFramesCount === flatImages.length) {
                        this.renderGif(gifElm);
                    }
                } else {
                    imageELement.onload = () => {
                        loadedFramesCount += 1;
                        gifElm.addFrame(imageELement, {delay: frameDelay});
                        if(loadedFramesCount === flatImages.length) {
                            this.renderGif(gifElm);
                        }
                    };
                    imageELement.onerror = (error) => {
                        console.error('Error loading image =>', error);
                    }
                }
            });
        },
        renderGif(gifElm) {
            gifElm.on('finished', function(blob){
                let gifImgEl = new Image();
                
                // create link to image from blob
                let imgBlobURL = URL.createObjectURL(blob);

                gifImgEl.setAttribute("src", imgBlobURL);
                gifCont.appendChild(gifImgEl);
                
                this.gifImage.blobURL = imgBlobURL;
                this.gifImage.imageBlob = blob;
                this.emitGifImage();
                
            }.bind(this));
            
            let gifCont = this.$refs["gifCont"];
            
            if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                // delay on mobile to make sure all images are loaded
                setTimeout(() => {
                    gifElm.render();
                }, 1000);
            } else {
                gifElm.render();
            }
        },
        emitGifImage(){
            this.$emit('gifImage', this.gifImage);
        }
    },
    created() {
    },
    computed: {
        gifLocalData: function() {
            let defaultData =  {
                quizQuestion: "Who are you dude? Do I even know you?",
                quizAnswers: [
                    "Pikatchu",
                    "Banana",
                    "Strawberry",
                    "خرية",
                    "💩",
                    "🍑",
                ],
                quizColor: "#0F6FFF",
                creditInfo: {
                    name: "Mahdi Farra",
                    email: "me@mahdif.com",
                },
                quizIsPrivate: true,
            };
            
            let data = {};
            // if gif data is available parse JSON, else use defaultData object
            data = this.gifData && this.gifData.quizAnswers.length ? JSON.parse(JSON.stringify(this.gifData)) : defaultData;
            return data;
        }
    },
    mounted() {
        // Auto-create gif when this component is shown
        this.createCanvasImagesThenGif();
    },
}
</script>

<style >
    .gif-generator-main-cont {
        background-color: white;
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        overflow: auto;
        z-index: 99;
        /* ==== Hide page content ==== */
        top: -100%;
        left: -100%;
        opacity: 0;
    }
    .gif-divs-canvas-cont {
        display: grid;
        background: rgba(0,0,0,0.05);
        gap: 24px;
    }
    .gif-card-templates, .gif-card-canvas-images {
        background: rgba(0,0,0,0.05);
        display: flex;
        flex-direction: row;
    }

    .gif-card-templates .gif-img-template, .gif-card-canvas-images img {
        margin-right: 16px;
    }

    .gif-img-ref {
        font-size: calc(10em / 16);
        opacity: 1;
        width: 100%;
        word-break: break-word;
    }
    .gif-img-ref .result_instructions,  .gif-img-ref .referral_desc {
        display: block;
        width: 100%;
    }
    .gif-img-ref .result_instructions {
        font-weight: 700;
        opacity: 0.6;
    }
    .gif-img-ref .referral_desc {
        opacity: 0.4;
    }

    .created-gif-cont {
        border: solid 4px orangered;
        display: flex;
        align-self: baseline;
        justify-content: center;
        align-items: center;
        width: 360px;
    }
    .created-gif-cont img {
        max-width: 100%;
    }

    .pageBtns {
        width: 100%;
        padding: 24px;
        background: lightblue;
        margin-bottom: 24px;
    }
    .pageBtns button {
        margin-right: 24px;
    }
</style>